import React, { useState, useEffect } from "react";
import styles from "./navigation.scss";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
import { useQueryParams } from "@tw/shared-ui-components/lib/hooks/useQueryParams";
const Navigation = ({
  className,
  navigationMenus = [],
  Link,
  type,
  exStyles,
  navDomHeight,
  callback
}) => {
  const NextLink = Link || "a";
  const queryParams = useQueryParams();

  const [selectedCat, setSelectedCat] = useState("");
  const [UTM_PATAMS_1, setUTM_PATAMS_1] = useState('')
  const [UTM_PATAMS_2, setUTM_PATAMS_2] = useState('')
  useEffect(() => {
    setUTM_PATAMS_1(getQueryUTMString("&"))
    setUTM_PATAMS_2(getQueryUTMString("?"))
  }, [queryParams])
  const handleOnClick = (key, code) => {
    if (key === "cat") setSelectedCat(code);
  };
  const getHrefUrl = (url) => {
    if (url) {
      return url.includes("?") ? `${url}${UTM_PATAMS_1}` : `${url}${UTM_PATAMS_2}`
    }

  }
  // const baseURL ='https://shop-qa.amwaynet.com.tw/category/'
  const baseURL = "/category/";
  if (navigationMenus.length == 0) return null;
  return (
    <div
      className={`${styles.container} ${styles[className]}`}
      style={exStyles}
    >
      <div
        className={styles.category}
        style={{ maxHeight: `calc(100vh - ${navDomHeight}px)` }}
      >
        {navigationMenus.map((item) => {
          if (type === "discover")
            return (
              <div
                key={`navCat-${item.code}`}
                className={`${styles.catItem} ${selectedCat === item.code ? styles.selected : ""
                  }`}
                onMouseEnter={() => handleOnClick("cat", item.code)}
              >
                <NextLink
                  href={
                    item.redirectUrl && getHrefUrl(`${item.redirectUrl}`) || item.code && getHrefUrl(`${baseURL}${item.code}`)}
                  passHref
                >
                  <a onClick={callback}>
                    <div>
                      <img src={item.icon} />
                    </div>
                    <div>{item.name}</div>
                  </a>
                </NextLink>
              </div>
            );
          else
            return (
              <div
                key={`navCat-${item.code}`}
                onMouseEnter={() => handleOnClick("cat", item.code)}
                className={`${styles.catItem} ${selectedCat === item.code ? styles.selected : ""
                  }`}
              >
                <div>
                  <img src={item.icon} />
                </div>
                <div>{item.name}</div>
              </div>
            );
        })}
      </div>
      {
        selectedCat && navigationMenus.filter((item) => item.code === selectedCat)[0]?.type !== "discover" &&
        <div
          className={styles.subCategory}
          style={{ maxHeight: `calc(100vh - ${navDomHeight}px)` }}
        >
          {navigationMenus.filter((item) => item.code === selectedCat)[0]
            .subCategories.length > 0 && (
              <>
                {navigationMenus
                  .filter((item) => item.code === selectedCat)[0]
                  .subCategories.map((subItem) => {
                    return (
                      <div
                        key={`navSubCat-${subItem.code}`}
                        className={styles.subCatItem}
                      >
                        <NextLink
                          href={subItem.redirectUrl && getHrefUrl(`${subItem.redirectUrl}?navigationType=${subItem?.type}`) || subItem.code && getHrefUrl(`${baseURL}${subItem.code}?navigationType=${subItem?.type}`)}
                          passHref
                        >
                          <a onClick={callback}>{subItem.name}</a>
                        </NextLink>
                      </div>
                    );
                  })}
              </>
            )}
          <div className={styles.subCatItem}>
            <NextLink
              href={
                navigationMenus.filter((item) => item.code === selectedCat)[0].redirectUrl && getHrefUrl(`${navigationMenus.filter((item) => item.code === selectedCat)[0].redirectUrl}?navigationType=${navigationMenus.filter((item) => item.code === selectedCat)[0].type}`)
                ||
                navigationMenus.filter((item) => item.code === selectedCat) && getHrefUrl(`${baseURL}${navigationMenus.filter((item) => item.code === selectedCat)[0].code}?navigationType=${navigationMenus.filter((item) => item.code === selectedCat)[0].type}`)
              }
              passHref
            >
              <a onClick={callback}> 檢視全部產品 </a>
            </NextLink>
          </div>
        </div>
      }

    </div>
  );
};

export default Navigation;
// https://shop-qa.amwaynet.com.tw/category/d1003?type=%223eprogram%22
